<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller"/>

    <!-- HEADER -->
    <div class="header bg-gradient-primary pb-8 pt-5 pt-md-8 hide">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7">
      <div class="row">
        <div>
          <b-btn v-b-toggle.collapse1 variant="primary">Toggle Collapse</b-btn>
          <b-collapse id="collapse1" class="mt-2">
            <b-card>
              <p class="card-text">Collapse contents Here</p>
              <b-btn v-b-toggle.collapse1_inner size="sm">Toggle Inner Collapse</b-btn>
              <b-collapse id="collapse1_inner" class="mt-2">
                <b-card>Hello!</b-card>
              </b-collapse>
            </b-card>
          </b-collapse>
        </div>
        <div class="col-lg-12">
          <div class="card bg-secondary row-access">
            <div class="card-header">Accesos y Permisos</div>
            <div class="card-body">
              <!-- Department Iteration -->
              <div v-for="(dep, index) in departments" :key="index">
                <div class="card-title">
                  <span
                    class="btn-action"
                    :class="{'active': dep.active}"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Ver registros"
                  >
                    <li class="fa fa-check"></li>
                  </span>
                  <button
                    class="btn btn-link btn-dpto"
                    type="button"
                    data-toggle="collapse"
                    :data-target="'#collapseDep'+index"
                    aria-expanded="false"
                  >{{ dep.caption }}</button>
                </div>
                <div class="mt-2 collapse" :id="'collapseDep'+index">
                  <div class="card card-body">
                    <!-- Menu Iteration -->
                    <div v-for="(menu, indexMenu) in dep.menu" :key="indexMenu">
                      <div class="card-title">
                        <button
                          class="btn btn-link btn-menu"
                          type="button"
                          data-toggle="collapse"
                          :data-target="'#collapseMenu_'+ dep.id+ '_' + indexMenu"
                          aria-expanded="false"
                        >
                          <i
                            v-if="menu.submenu.length > 0"
                            class="fa fa-arrow-down arrow-more"
                            aria-hidden="true"
                          ></i>
                          {{ menu.caption }}
                        </button>
                        <span
                          class="btn-action"
                          :class="{'active': menu.active}"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Ver registros"
                        >
                          <li class="fa fa-check"></li>
                        </span>
                        <template v-if="menu.submenu.length == 0">
                          <span
                            class="btn-action"
                            :class="{'active': menu.actions.post}"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Agregar registros"
                          >
                            <li class="fa fa-plus"></li>
                          </span>
                          <span
                            class="btn-action"
                            :class="{'active': menu.actions.put}"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Editar registros"
                          >
                            <li class="fa fa-edit"></li>
                          </span>
                          <span
                            class="btn-action"
                            :class="{'active': menu.actions.delete}"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Eliminar registros"
                          >
                            <li class="fa fa-times"></li>
                          </span>
                        </template>
                      </div>
                      <template v-if="menu.submenu.length > 0">
                        <div class="mt-2 collapse" :id="'collapseMenu_'+ dep.id+ '_' + indexMenu">
                          <div class="card card-body">
                            <!-- Submenu Iteration -->
                            <div v-for="(submenu, indexSub) in menu.submenu" :key="indexSub">
                              <div class="card-title">
                                <button
                                  class="btn btn-link btn-menu btn-submenu"
                                  type="button"
                                >{{ submenu.caption }}</button>
                                <span
                                  class="btn-action"
                                  :class="{'active': submenu.active}"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Ver registros"
                                >
                                  <li class="fa fa-check"></li>
                                </span>
                                <span
                                  class="btn-action"
                                  :class="{'active': submenu.actions.post}"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Agregar registros"
                                >
                                  <li class="fa fa-plus"></li>
                                </span>
                                <span
                                  class="btn-action"
                                  :class="{'active': submenu.actions.put}"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Editar registros"
                                >
                                  <li class="fa fa-edit"></li>
                                </span>
                                <span
                                  class="btn-action"
                                  :class="{'active': submenu.actions.delete}"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Eliminar registros"
                                >
                                  <li class="fa fa-times"></li>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "accesos",
  data() {
    return {
      controller: {
        title: "Accesos",
        mainRouter: "/"
      },
      hijomio: 'collapse1',
      departments: [
        {
          id: 1,
          name: "launchpadslug",
          caption: "Operaciones",
          active: false,
          menu: [
            {
              id: 1,
              name: null,
              caption: "Sospechosos",
              active: false,
              actions: {
                put: false,
                post: false,
                delete: false
              },
              submenu: [
                {
                  id: 1,
                  name: "baneados",
                  caption: "Baneados",
                  active: true,
                  actions: {
                    put: true,
                    post: true,
                    delete: true
                  }
                }
              ]
            }
          ]
        },
        {
          id: 3,
          name: "launchpadslug",
          caption: "Automotoras",
          active: false,
          menu: [
            {
              id: 3,
              name: "clients",
              caption: "Clientes",
              active: false,
              actions: {
                put: true,
                post: false,
                delete: false
              },
              submenu: []
            },
            {
              id: 6,
              name: "usersA",
              caption: "Usuarios LiveMarket",
              active: false,
              actions: {
                put: true,
                post: true,
                delete: false
              },
              submenu: []
            }
          ]
        },
        {
          id: 4,
          name: "launchpadslug",
          caption: "T. Información",
          active: true,
          menu: [
            {
              id: 4,
              name: "users",
              caption: "Usuarios",
              active: false,
              actions: {
                put: false,
                post: false,
                delete: false
              },
              submenu: []
            }
          ]
        },
        {
          id: 5,
          name: "launchpadslug",
          caption: "Marketing",
          active: false,
          menu: [
            {
              id: 5,
              name: null,
              caption: "DFP",
              active: false,
              actions: {
                put: true,
                post: true,
                delete: false
              },
              submenu: [
                {
                  id: 2,
                  name: "leads",
                  caption: "Leads",
                  active: false,
                  actions: {
                    put: true,
                    post: false,
                    delete: false
                  }
                }
              ]
            }
          ]
        }
      ]
    };
  }
};
</script>